import { subscriptionHandler } from '../resources/accountSubscriptionResource';
import ChargingStationByIdResource from '../resources/ChargingStationById';
import { chargingStationsMetadataResource } from '../resources/ChargingStationListMetadata';
import { fetchChargingStationsCluster } from '../resources/ChargingStationsClusterResource';
import featureTogglesResource from '../resources/featureTogglesResource';

export const handlers = [
    subscriptionHandler({ SRP: true, eMSP: true }),
    featureTogglesResource,
    ChargingStationByIdResource,
    fetchChargingStationsCluster,
    chargingStationsMetadataResource.success,
];
